import { render, staticRenderFns } from "./subPageEight.vue?vue&type=template&id=72e647f4&scoped=true"
var script = {}
import style0 from "./subPageEight.vue?vue&type=style&index=0&id=72e647f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e647f4",
  null
  
)

export default component.exports